import { render, staticRenderFns } from "./ReportedBusinesses.vue?vue&type=template&id=638a4d23&scoped=true"
import script from "./ReportedBusinesses.vue?vue&type=script&lang=js"
export * from "./ReportedBusinesses.vue?vue&type=script&lang=js"
import style0 from "./ReportedBusinesses.vue?vue&type=style&index=0&id=638a4d23&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "638a4d23",
  null
  
)

export default component.exports